import React, { useState, useEffect } from "react";
import { txtA } from "../../../Label/Lbl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useInvCa } from "../../../St/Reviews/UseStyle";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import { stElemnt } from "../../../St/Reviews/cStyle";

export const useStylesNoTaxCashair = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3),
    },

    allWidth: {
        fontSize: "0.8rem",
        fontWeight: "bold",
    },
    checStyl: {
        border: "solid 2px",
        fontSize: "0.8rem",
        fontWeight: "bold",
        textAlign: "center",
        marginLeft: "-0.2cm",
        marginRight: "-0.2cm",
    },
    checStyl11: {
        fontSize: "0.78rem",
        fontWeight: "bold",
        textAlign: "center",
        marginLeft: "-0.2cm",
        marginRight: "-0.2cm",
    },
    checStyl2: {
        fontSize: "0.7rem",
        fontWeight: "bold",
        textAlign: "right",
        marginBottom: 2,
    },
    checStyl3: {
        border: "solid 1px",
        fontSize: "0.6rem",
        fontWeight: "bold",
        textAlign: "center",
        padding: "7px 1px",
    },
    checStyl4: {
        border: "solid 1px",
        fontSize: "0.5rem",
        fontWeight: "bold",
        textAlign: "center",
        padding: "5px 1px",
    },
    checStyl5: {
        fontSize: "0.6rem",
        fontWeight: "bold",
        textAlign: "center",
        padding: "3px 1px",
    },
    checStyl6: {
        border: "solid 1px",
        fontSize: "0.6rem",
        fontWeight: "bold",
        textAlign: "center",
        padding: "3px 1px",
    },
}));

const BodyCashier1 = (props) => {
    const clas = useInvCa();
    const { data,sta, locInv, onUnmountComplete } = props;
    const classes = useStylesNoTaxCashair();
    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.75rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleCe = {
        fontFamily: "Amiri-Regular",
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.65rem",
        color: "black",
        fontWeight: "bold",
        padding:"0.1px"
    };

    const cellSName = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.7rem",
        width: "600px",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
    };
    const cellS = {

        padding: "0px 0.1px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.8rem",
        width: "250px",
        textAlign: "right",
        paddingRight: "0.7rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem"
    };
    var columns = [
        { title: "#", field: "no", headerStyle: styleE, cellStyle: cellS, },
        { title: "اسم الصنف", field: "symbol", headerStyle: styleE, cellStyle: cellSName, },
        { title: "الكمية", field: "val1", headerStyle: styleE, cellStyle: cellS, },
        { title: "السعر", field: "new_exchange_price", headerStyle: styleE, cellStyle: cellS, },
        { title: "الاجمالي", field: "tot_net_curr", headerStyle: styleE, cellStyle: cellS },
    ];
    const newData = data.map((row, i) => {
        return {
            ...row,
            no:i+1,
            tot_net_curr: parseFloat(row.tot_net_curr).toFixed(2),
            new_exchange_price: parseFloat(row.new_exchange_price).toFixed(2),
        };
    });

    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 0);
    }, []);


    const totalsContntE_ = () => {
        return (
            <Grid item container className={classes.checStyl2}>
                <Grid item xs={4} className={classes.checStyl5}>
                  <div style={{fontWeight:"bold", fontSize:"0.9rem"}}> 
                     {((sta?.tot?.tot_net - sta?.tot?.amountOfVat + sta?.tot?.discount)-parseFloat(sta?.tot?.tab3Vat??0) ) ?.toFixed(2)}

                      </div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl2}>
                    <Grid item className={classes.checStyl5} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={12}>
                        الاجمالي قبل الضريبة
                    </Grid>
                </Grid>

                <Grid item xs={4} className={classes.checStyl5} style={{fontWeight:"bold", fontSize:"0.8rem"}}>                  
                    <div style={{fontWeight:"bold", fontSize:"1rem"}}> 
                    {sta.tot.discount?.toFixed(2)} </div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl5} style={{fontWeight:"bold", fontSize:"0.8rem"}}>
                    {txtA.totdiscount}
                </Grid>

                <Grid item xs={4} className={classes.checStyl5}>                   
                    <div style={{fontWeight:"bold", fontSize:"0.9rem"}}> 
                    {/* {(sta.tot.tot_net - sta.tot.amountOfVat)?.toFixed(2)} */}
                    {((sta?.tot?.tot_net - sta?.tot?.amountOfVat )-parseFloat(sta?.tot?.tab3Vat??0) ) ?.toFixed(2)}

                    </div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl5} style={{fontWeight:"bold", fontSize:"0.8rem"}}>
                    <Grid item xs={12}>
                        الاجمالي الخاضع للضريبة
                    </Grid>
                </Grid>
                {parseFloat(sta?.tot?.tab3Vat) > 0 &&
                    (
                        <>
                            <Grid item xs={4} className={classes.checStyl5}>
                                <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                                    {sta?.tot?.tab3Vat?.toFixed(2)}</div>
                            </Grid>
                            <Grid item xs={8} className={classes.checStyl5}>
                                <Grid item className={classes.checStyl5} xs={12} style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                                {"مجموع ضريبة التبغ"}
                                </Grid>
                            </Grid>
                        </>
                    )}
                <Grid item xs={4} className={classes.checStyl5}>                  
                    <div style={{fontWeight:"bold", fontSize:"0.9rem"}}> 
                    {sta.tot.amountOfVat?.toFixed(2)}</div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl5}>
                    <Grid item className={classes.checStyl5} xs={12} style={{fontWeight:"bold", fontSize:"0.8rem"}}>
                        {"(15%)إجمالي الضريبة"}
                    </Grid>
                </Grid>
                <Grid item className={classes.checStyl6} xs={4}>                 
                    <div style={{fontWeight:"bold", fontSize:"0.9rem"}}> 
                    {sta.tot.tot_net?.toFixed(2)}</div>
                </Grid>
                
                <Grid item className={classes.checStyl6} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={8}>
                    <Grid item className={classes.checStyl5} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={12}>
                        الاجمالي شامل الضريبه   
                    </Grid>
                </Grid>
                <Grid item className={classes.checStyl6} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={6}>
                    {" متبقي"}
                    {"\n"}
                    {sta.tot?.inv_type_name == "نقدية"
                        ? 0
                        : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
                </Grid>
                <Grid item className={classes.checStyl6} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={6}>
                    {" مدفوع"}
                    {"\n"}
                    {sta?.tot?.inv_type_name == "نقدية"
                        ? sta?.tot?.tot_net?.toFixed(2)
                        : sta?.tot?.paid}
                </Grid>

                <Grid item className={classes.checStyl6} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={5}>
                    {" بعد"}
                    {"\n"}
                    {sta.tot?.cust_balance_new?.toFixed(2)}
                </Grid>
                <Grid item className={classes.checStyl6} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={5}>
                    {" قبل"}
                    {"\n"}
                    {sta.tot?.cust_balance_old?.toFixed(2)}
                </Grid>
                <Grid item className={classes.checStyl6} style={{fontWeight:"bold", fontSize:"0.8rem"}} xs={2}>
                    {"الرصيد "}
                </Grid>
            </Grid>
        );
    };

    return (
        <Grid item container className={clas.Bdyroot}>
            <Grid item container className={clas.BdyundrHeaderTF}>
                {locInv.ProcTypeInvProc != "03" && (
                    <Grid item xs={12}>
                        <Typography className={classes.checStyl11}>
                            {sta.tot.tax_no_cust === ""
                                ? "فاتورة ضريبية مبسطة"
                                : "فاتورة ضريبية"}
                        </Typography>
                        {/* <Typography className={[clas.contnt,clasm.minclr]}>{"titlee"}</Typography> */}
                    </Grid>
                )}

                <Grid item xs={12}>
                    <Typography className={classes.checStyl}>
                        {locInv.invN +
                            " " +
                            sta.tot.inv_type_name +
                            " " +
                            sta.tot.pay_type_name}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item container >
            <Grid item container style={{ fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
            <Grid item xs={8} style={styleE}>
                    {sta.tot.id}
                </Grid>
                <Grid item xs={4} style={styleE}>
                    {'رقم الفاتورة'}
                </Grid>
                <Grid item xs={8} style={styleE}>
                {moment(sta.tot.date).format("YYYY/MM/DD")}  {moment(sta.tot.date).format("hh:mm A")}
                </Grid>
                <Grid item xs={4} style={styleE}>
                    {'تاريخ الفاتورة'}
                </Grid>
                <Grid item xs={8} style={styleE}>
                    {sta.tot.cust_name}
                </Grid>
                <Grid item xs={4} style={styleE}>
                    {'اسم العميل'}
                </Grid>
                <Grid item xs={8} style={styleE}>
                {sta?.tot?.cust_address + " - " + sta?.tot?.cust_mobile}
                </Grid>
                <Grid item xs={4} style={styleE}>
                {'بيانات العميل'}  
                </Grid>
                <Grid item xs={8} style={styleE}>
                    {sta.tot?.tax_vat_registration_no_cust}
                </Grid>
                <Grid item xs={4} style={styleE}>
                    {"رقم السجل"}
                </Grid>
                <Grid item xs={8} style={styleE}>
                    {sta.tot.tax_no_cust}
                </Grid>
                <Grid item xs={4} style={styleE}>
                    {'الرقم الضريبي'}
                </Grid>
            </Grid>
        </Grid>
            <Grid
                item
                xs={12}
                style={{direction:"rtl"}}
            >
                <MaterialTable
                    style={{ boxShadow: "none" }}
                    options={{
                        showTitle: false,
                        toolbar: false,
                        sorting: false,
                        selection: false,
                        searchFieldAlignment: "left",
                        searchFieldVariant: "outlined",
                        showSelectAllCheckbox: false,
                        showTextRowsSelected: false,
                        pageSize: 5,
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        paging: false,
                        headerStyle: stElemnt.EvDay.header,
                        cellStyle: {
                            ...stElemnt.AF.cell,
                            padding: "0px 1px",
                        },

                    }}
                    localization={{
                        body: {
                            emptyDataSourceMessage: (
                                <h5 style={{ color: "GrayText" }}>
                                    لا توجد ارصدة بعد في هذا الحساب
                                </h5>
                            ),
                        },
                    }}
                    columns={columns}
                    data={newData}
                />

            </Grid>
            {totalsContntE_()}
        </Grid>
    );
};
export default BodyCashier1;
